import { render } from "./HeroApprovalTravelModal.vue?vue&type=template&id=081f4e02&scoped=true"
import script from "./HeroApprovalTravelModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalTravelModal.vue?vue&type=script&lang=js"

import "./HeroApprovalTravelModal.vue?vue&type=style&index=0&id=081f4e02&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081f4e02"]])

export default __exports__